import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { merge, Observable } from 'rxjs';
import { ReportLocation, ReportRequestBody, ReportTimePeriod, ReportType } from '@mona/models';
import * as ReportsActions from '../state';
import * as ReportsSelectors from '../state';

/**
 * Reports facade service
 */
@Injectable({
    providedIn: 'root',
})
export class ReportsFacade {
    /** Is loading */
    isLoading$: Observable<boolean> = merge(
        this.store.select(ReportsSelectors.selectReportTypesIsLoading),
        this.store.select(ReportsSelectors.selectLocationsIsLoading),
        this.store.select(ReportsSelectors.selectTimePeriodsIsLoading),
    );

    /**
     * Get report types
     */
    reportTypes$: Observable<ReportType[]> = this.store.select(ReportsSelectors.selectReportTypes);
    /**
     * Get report locations
     */
    reportLocations$: Observable<ReportLocation[]> = this.store.select(ReportsSelectors.selectLocations);
    /**
     * Get report time periods
     */
    timePeriods$: Observable<ReportTimePeriod[]> = this.store.select(ReportsSelectors.selectTimePeriods);
    /**
     * Constructor
     *
     * @param store store
     */
    constructor(private store: Store<any>) {}

    /**
     * Dispatch load report types
     */
    loadReports(): void {
        this.store.dispatch(ReportsActions.loadReportTypes());
    }

    /**
     * Dispatch load report locations
     */
    loadReportLocations(): void {
        this.store.dispatch(ReportsActions.loadReportsExportLocations());
    }

    /**
     * Dispatch load report time periods
     */
    loadReportsTimePeriods(): void {
        this.store.dispatch(ReportsActions.loadReportsTimePeriods());
    }

    /**
     * Dispatch full export report
     *
     * @param exportReportRequest
     */
    exportReport(exportReportRequest: ReportRequestBody): void {
        this.store.dispatch(ReportsActions.exportReport(exportReportRequest));
    }

    /**
     * Clear report
     */
    clearReportTypes(): void {
        this.store.dispatch(ReportsActions.clearReportTypes());
    }
}
